import { Directive, ViewContainerRef, TemplateRef, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Directive({
    selector: '[isPowerEngineer]',
    standalone: false
})
export class IsPowerEngineerDirective implements OnInit {
  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private authService: AuthService) {}

  public ngOnInit(): void {
    if (this.authService.isPowerEngineer()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
